import * as React         from 'react'
import { useTranslation } from 'react-i18next'
import { useApi }         from '../utils/api'
import { useSnackbar }    from 'notistack'
import { IconButton }     from '@mui/material'
import AlertSimpleDialog  from '../ui/components/alert-simple-dialog'
import { fDateTime }      from '../utils/textutils'
import Iconify            from '../ui/components/Iconify'
import { useContext }     from 'react'
import { AppContext }     from '../App'

export default function ScheduledChangeDeleteDialog({ change, onResult }) {

    const api = useApi()
    const { user } = useContext(AppContext)
    const { t } = useTranslation()
    const [open, setOpen] = React.useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = (result) => {
        setOpen(false)
        if (!!onResult) {
            onResult(result)
        }
    }

    return (
        <React.Fragment>
            <IconButton size={'small'} color={'error'} onClick={handleClickOpen} disabled={user?.readonly}>
                <Iconify icon={'material-symbols:delete'}/>
            </IconButton>
            <AlertSimpleDialog
                title={t('Delete scheduled change')}
                message={t('delete-scheduled-change-confirm', { scheduled: fDateTime(change?.scheduled) })}
                open={open}
                onClose={async (result) => {
                    if (!result){
                        handleClose(result)
                        return
                    }
                    api.scheduleChange.delete(change.id).then(() => {
                        enqueueSnackbar(t('Scheduled change deleted'), {
                            variant: 'success'
                        })
                    }).catch(error => {
                        enqueueSnackbar(t('Failed to delete scheduled change'), {
                            variant: 'error'
                        })
                    }).finally(() => {
                        handleClose(result)
                    })
                }}
            />
        </React.Fragment>
    )
}